// @flow
import type { CountryLanguage } from '~/core/types/beekeeper';

import { fromJS } from 'immutable';
import { createSelector } from 'reselect';

const getState = state => state.user || fromJS({});

// $FlowFixMe
export const getAlerts = createSelector(getState, state => state.get('alerts'));
export const getAnalyticsSharingAllowed = createSelector(getState, user =>
    // $FlowFixMe
    user.getIn(['media', 'allowAnalyticsSharing'])
);
// $FlowFixMe
export const getLastActivity = createSelector(getState, state => state.get('lastActivity'));
// $FlowFixMe
export const getSettingPin = createSelector(getState, state => state.get('settingPin'));
// $FlowFixMe
export const getSettingPinError = createSelector(getState, state => state.get('settingPinError'));
// $FlowFixMe
export const getUser = createSelector(getState, state => state.getIn(['userDetails'], fromJS({})));

export const getPostcode = createSelector(getUser, state => state.get('postcode'));
export const getUserCountry = createSelector(getUser, state => state.get('countryCode'));
export const getUserId = createSelector(getUser, state => state.get('id'));
export const getUserPhone = createSelector(getUser, state => state.get('mobile') || state.get('phone'));
export const getUserUsername = createSelector(getUser, state => state.get('username'));
export const getUserLocale = createSelector(getUser, (user): CountryLanguage => user.get('locale'));
export const getUserEmail = createSelector(getUser, user => user.get('email'));



// WEBPACK FOOTER //
// ./src/core/state/user/selectors.js